// Costanti CRM condivise lato frontend (mirror dei valori backend).
export const OPP_PRODUCTS = ["Fotovoltaico", "Sistema di accumulo", "Climatizzazione", "Pompa di calore", "Caldaia", "Wallbox", "Altro"];
export const OPP_STAGES = ["Nuovo lead", "Contattato", "Appuntamento", "Sopralluogo", "Preventivo da preparare", "Preventivo inviato", "Follow-up", "Trattativa", "Vinta", "Persa"];
export const OPP_CLOSED = ["Vinta", "Persa"];
export const PRIORITIES = ["Alta", "Media", "Bassa"];
export const LOST_REASONS = ["Prezzo", "Concorrente", "Non più interessato", "Finanziamento", "Tempistiche", "Problema tecnico", "Altro"];
export const LEAD_ORIGINS = ["Passaggio spontaneo", "Cliente esistente", "Telefonata", "Segnalazione", "Social", "Google", "Campagna", "Agente", "Altro"];
export const QUOTE_STATUS = ["Bozza", "Pronto", "Inviato", "Follow-up", "Modificato", "Accettato", "Rifiutato", "Scaduto"];
export const QUOTE_CATEGORIES = ["Commodity", "Efficienza"];
export const QUOTE_PRODUCTS = ["Fotovoltaico", "Sistema di accumulo", "Climatizzazione", "Pompa di calore", "Caldaia", "Wallbox", "Luce", "Gas", "Fibra", "Altro"];
export const QUOTE_SENT_CHANNELS = ["Email", "WhatsApp", "Consegna a mano", "Altro"];
export const QUOTE_LOST_REASONS = ["Prezzo", "Concorrente", "Non più interessato", "Finanziamento", "Tempistiche", "Problema tecnico", "Soluzione non adatta", "Altro"];

export function stageTone(stage) {
  if (stage === "Vinta") return "success";
  if (stage === "Persa") return "danger";
  if (["Trattativa", "Preventivo inviato", "Follow-up"].includes(stage)) return "warning";
  return "info";
}

export function nextActionInfo(dateStr, hasAction) {
  if (!hasAction) return { level: "none", label: "Senza azione", tone: "danger" };
  if (!dateStr) return { level: "nodate", label: "Senza data", tone: "warning" };
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const d = new Date(dateStr); d.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return { level: "overdue", label: "Scaduta", tone: "danger" };
  if (days === 0) return { level: "today", label: "Oggi", tone: "warning" };
  if (days <= 7) return { level: "soon", label: `Tra ${days}g`, tone: "info" };
  return { level: "ok", label: "", tone: "neutral" };
}

export function priorityTone(p) {
  return p === "Alta" ? "danger" : p === "Media" ? "warning" : "neutral";
}

export function quoteStatusTone(s) {
  if (s === "Accettato") return "success";
  if (["Rifiutato", "Scaduto"].includes(s)) return "danger";
  if (["Inviato", "Follow-up", "Modificato"].includes(s)) return "warning";
  if (s === "Pronto") return "info";
  return "neutral";
}

export function eur(v) {
  if (v == null) return "—";
  return "€ " + Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export async function downloadQuotePdf(api, quoteId, number) {
  const res = await api.get(`/quotes/${quoteId}/pdf`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url; a.download = `${number || "preventivo"}.pdf`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
}
